import { capitalize } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import useMain from '../../../../hooks/useMain';
import { numberWithCommas, titleCase } from '../../../../utils/helpers';
import { FlippingDebit, FlippingMMICard, TextCard } from '../../ingredients/cards';

const Cards = () => {
	const { initData, userData, theme } = useMain();
	const {
		mmi,
		card,
		isAboveAlert,
		MMIUsedMaxCap,
		totalCardsUsedMaxCap,
		maxCap,
		userCards,
		currentCard,
	} = userData;
	const { mmiConfig } = initData;
	const totalUsedMaxCap = MMIUsedMaxCap + totalCardsUsedMaxCap;

	return (
		<div className='col-lg-6'>
			<div className='row'>
				<div className='col-12'>
					<TextCard
						text={
							<>
								<div className='d-flex justify-content-center flex-wrap text-center fs-6'>
									<div className='me-3'>
										<span className='fw-bold'>Total MaxCap:</span>{' '}
										{numberWithCommas(userData.maxCap / 1e6)} $
									</div>
									<div className='me-3'>
										<span className='fw-bold'>Used MaxCap:</span>{' '}
										<span
											className={`text-my-${
												isAboveAlert ? 'danger' : 'success'
											}`}>
											{maxCap === 0
												? 0
												: ((totalUsedMaxCap * 100) / maxCap).toFixed(2)}
											%
										</span>
									</div>
									<div>
										<span className='fw-bold'>Remaining MaxCap:</span>{' '}
										{numberWithCommas((maxCap - totalUsedMaxCap) / 1e6)} $
									</div>
								</div>
								<hr />
								<div className='row mt-4'>
									<div className='col-xl-6 text-center'>
										<FlippingDebit
											card={userData.currentCard.name}
											text={userData.bemchain.uid}
										/>
										<div className='my-3'>
											<div>
												<div className='fw-bold'>Class:</div>
												<div>{capitalize(userData.class)}</div>
											</div>
											<div>
												<span className='fw-bold'>Active Cards:</span>{' '}
												{
													userCards.filter((i) => i.status === 'active')
														.length
												}
											</div>
											<div>
												<div className='fw-bold'>Highest Card:</div>{' '}
												<div>
													{titleCase(
														`${currentCard.name} ${
															currentCard.name !== 'white'
																? userData.class
																: ''
														} card`
													)}
												</div>
											</div>
										</div>
										<Link
											className={`btn btn-set2-${theme} mb-4`}
											to={'/dashboard/packages/purchasePackage'}>
											MMP Package
										</Link>
									</div>
									<div className='col-xl-6 text-center'>
										<FlippingMMICard
											mmi={userData.mmi}
											bc={userData.bemchain.uid}
										/>
										<div className='my-3'>
											<div>
												<span className='fw-bold'>
													MMI Contract Period:
												</span>{' '}
												{mmi.isActive
													? mmi.contractPeriod + ' years'
													: 'Inactive'}
											</div>
											<div>
												<span className='fw-bold'>MMI Payment Method:</span>{' '}
												{mmi.isActive
													? mmiConfig.paymentMethod.find(
															(m) => m.duration === mmi.paymentMethod
													  ).content
													: 'Inactive'}
											</div>
											<div>
												<span className='fw-bold'>
													MMI Increase Percent:
												</span>{' '}
												{mmi.isActive
													? mmi.increasePercent * 100 + '%'
													: 'Inactive'}
											</div>
											<div>
												<span className='fw-bold'>MMI Amount:</span>{' '}
												{mmi.isActive
													? '$' +
													  numberWithCommas(mmi.amount / 1e6) +
													  ' - ' +
													  mmiConfig.paymentMethod.find(
															(m) => m.duration === mmi.paymentMethod
													  ).content
													: 'Inactive'}
											</div>
											<div>
												<span className='fw-bold'>
													Last Year Profit Rate:
												</span>{' '}
												32%
											</div>
										</div>
										<Link
											className={`btn btn-set2-${theme}`}
											to={`/dashboard/mmi/${
												mmi.isActive
													? 'insuranceDashboard'
													: card === 'white'
													? 'purchaseInsurance'
													: 'migrate'
											}`}>
											MMI Package
										</Link>
									</div>
								</div>
							</>
						}
					/>
				</div>
			</div>
		</div>
	);
};

export default Cards;
